import req from '@/request.js'
import utils from '@/eco-ui-util.js'
import { Promise } from 'q'

const uc = req.getContext().uc
const uaa = req.getContext().uaa
const portal = req.getContext().portal
const business = req.getContext().business
export default {
  getRolePage(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/role/v1/roles/getRolePage', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
    // return roleData.getRolePageJson(param);
  },
  getSupplierPage(param) {
    return new Promise((resolve, reject) => {
      req.post(business + '/system/customer_register/query', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
    // return roleData.getRolePageJson(param);
  },
  disableOrg(id, status) {
    return new Promise((resolve, reject) => {
      req.get(uc + '/api/org/v1/org/updateStatusById?orgId=' + id + '&status=' + status).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateOrg(params) {
    return new Promise((resolve, reject) => {
      req.post(uc + `/api/org/v1/orgs/updateOrgPos${req.formatGetUri(params)}`, params).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getDesignPage(param) {
    return new Promise((resolve, reject) => {
      req.post(business + '/design/design_maketing_pro/query', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
    // return roleData.getRolePageJson(param);
  },
  getConstructionPro(param) {
    return new Promise((resolve, reject) => {
      req.post(business + '/construction/construction_pro/query', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
    // return roleData.getRolePageJson(param);
  },
  getMarketingPage(param) {
    return new Promise((resolve, reject) => {
      req.post(business + '/marketing/marketing_pro/query', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getUserPage(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/user/v1/users/listJson', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getOrgUserQuery(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/user/v1/users/getOrgUserQuery', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getUserByAccount(account, cb) {
    req.get(uc + `/api/user/v1/user/getDetailByAccountOrId?account=${account}`).then((rep) => {
      cb(rep.data)
    })
  },
  authentication(principal, cb, errorCb) {
    req
      .post(uaa + `/oauth/token${req.formatGetUri(principal)}`)
      .then(function (rep) {
        cb(rep.data)
      })
      .catch(function (error) {
        errorCb(error.message)
      })
  },
  loadUserByUsername(account, cb) {
    req.post(uc + `/api/user/v1/user/loadUserByUsername?account=${account}`).then((rep) => {
      cb(rep.data)
    })
  },
  basicSso(token, cb, errorCb) {
    let service = localStorage.getItem('service')
    req
      .get(uc + `/sso/auth?ticket=${token}&code=${token}&service=${service}`)
      .then(function (rep) {
        cb(rep.data)
      })
      .catch(function (error) {
        errorCb(error.message)
      })
  },
  getRoleDetail(id) {
    return new Promise((resolve, reject) => {
      req.get(uc + '/api/role/v1/role/getRole?code=' + id).then(
        (response) => {
          resolve(response.data.value)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  modifyPwd(data, cb) {
    req.post(uc + `/api/user/v1/user/changUserPsd`, data).then((rep) => {
      cb(rep.data)
    })
  },

  getAllDimension() {
    return new Promise((resolve, reject) => {
      req
        .get(`${uc}/api/demension/v1/dems/getAll`)
        .then(function (rep) {
          resolve(rep.data)
        })
        .catch(function (error) {
          reject(error.message)
        })
    })
  },

  getOrgsByDemension(demensionId, cb, errorCb) {
    req
      .post(uc + '/api/org/v1/orgs/getByParentAndDem', {
        demId: demensionId
      })
      .then(function (rep) {
        cb(utils.tile2nest(rep.data))
      })
      .catch(function (error) {
        errorCb && errorCb(error.message)
      })
  },

  getOrgsByParentIdAndDemension(parentId, demensionId, cb, errorCb) {
    req
      .post(uc + '/api/org/v1/orgs/getByParentAndDem', {
        demId: demensionId,
        parentId: parentId
      })
      .then(function (rep) {
        cb(rep.data)
      })
      .catch(function (error) {
        errorCb && errorCb(error.message)
      })
  },

  getUsersByOrgId(queryFilter) {
    return new Promise((resolve, reject) => {
      req
        .post(`${uc}/api/user/v1/users/queryByType`, queryFilter)
        .then(function (rep) {
          resolve(rep.data)
        })
        .catch(function (error) {
          reject(error.message)
        })
    })
  },

  getCurrentOrg(cb) {
    req.get(uc + `/api/org/v1/org/getOrgMaster`).then((rep) => {
      cb(rep)
    })
  },

  queryOrgByFilter(queryFilter) {
    return new Promise((resolve, reject) => {
      req
        .post(uc + '/api/org/v1/orgs/getOrgPage', queryFilter)
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getOrgPostPage(queryFilter) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/org/v1/orgPosts/getOrgPostPage', queryFilter).then((response) => {
        resolve(response.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  getJobPage(queryFilter) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/job/v1/jobs/getJobPage', queryFilter).then((response) => {
        resolve(response.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  // 查询维度列表
  getDemPage(queryFilter) {
    return new Promise((resolve, reject) => {
      req
        .post(uc + '/api/demension/v1/dems/getDemListAll', queryFilter)
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getRoleUsers(roleCode, queryFilter) {
    return new Promise((resovle, reject) => {
      req
        .request({
          url: `${uc}/api/role/v1/role/getRoleUsers`,
          data: queryFilter,
          method: 'POST',
          params: { code: roleCode },
          dataType: 'json'
        })
        .then(function (rep) {
          resovle(rep.data)
        })
        .catch(function (error) {
          reject(error.message)
        })
    })
  },
  saveUserRole(params) {
    return new Promise((resovle, reject) => {
      req
        .request({
          url: `${uc}/api/role/v1/roleUser/saveUserRole`,
          method: 'POST',
          params: params,
          dataType: 'json'
        })
        .then(function (rep) {
          resovle(rep.data)
        })
        .catch(function (error) {
          reject(error.message)
        })
    })
  },
  fileUpload(param) {
    //文件上传
    return new Promise((resolve, reject) => {
      req.post(portal + '/system/file/v1/fileUpload', param).then((response) => {
        resolve(response.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  getUser(param) {
    return new Promise((resolve, reject) => {
      req.get(uc + `/api/user/v1/user/getDetailByAccountOrId?account=${param}`).then((rep) => {
        resolve(rep.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  getUserOrgPage(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/org/v1/orgs/getUserOrgPage', param).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  userRolePage(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/user/v1/userRoles/userRolePage', param).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  setMasterById(Id) {
    return new Promise((resolve, reject) => {
      req.put(uc + '/api/org/v1/orgPost/setMasterById?id=' + Id).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  saveUserOrgs(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/org/v1/orgUser/addOrgUserByCode?account=' + param.account + '&orgCode=' + param.orgCode).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  saveUserPosts(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/org/v1/userPost/saveUserPosts?account=' + param.account + '&postCodes=' + param.Code).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  delOrgUser(id) {
    return new Promise((resolve, reject) => {
      req.remove(uc + '/api/org/v1/orgUser/delOrgUser?ids=' + id).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  saveUserRoles(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/role/v1/roleUser/saveUserRoles?account=' + param.account + '&codes=' + param.codes).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  delUserRole(param) {
    return new Promise((resolve, reject) => {
      req.remove(uc + '/api/role/v1/roleUser/deleteUserRole?accounts=' + param.account + '&code=' + param.codes).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  getUserByUserId(userId) {
    return new Promise((resolve, reject) => {
      req.get(uc + '/api/org/v1/orgpost/getUserByUserId?userId=' + userId).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  syncUserToWx(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/user/v1/users/syncUserToWx?userId=' + param).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  updateUserPsw(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/user/v1/user/updateUserPsw', param).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  // 获取所有的用户参数
  getUserParams() {
    return new Promise((resolve, reject) => {
      req.get(uc + '/api/params/v1/userParams/getUserParams').then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  // 获取指定用户的用户参数值
  getUserParamsValue(account) {
    return new Promise((resolve, reject) => {
      req.get(uc + `/api/user/v1/user/getUserParams?account=${account}`).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  // 保存指定用户的用户参数
  saveUserParams(data, param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/user/v1/user/saveUserParams', data, param).then((response) => {
        resolve(response.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  getRelAuthPage(data, param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/relAuth/v1/relAuths/getRelAuthPage', data, param).then((response) => {
        resolve(response.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  addRelAuths(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/relAuth/v1/relAuths/addRelAuths?code=' + param.code + '&accounts=' + param.accounts).then((response) => {
        resolve(response.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  getUserOrgNowNumByOrgIds(param) {
    return new Promise((resolve, reject) => {
      req.get(uc + '/api/org/v1/orgusers/getUserOrgNowNumByOrgIds?orgIds=' + param).then((resp) => {
        resolve(resp.data)
      }),
        (error) => {
          reject(error)
        }
    })
  },
  //添加汇报线
  addUserRel(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/userRel/v1/userRel/addUserRel', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  //修改汇报线
  updateUserRel(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/userRel/v1/userRel/updateUserRel', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  deleteUserRel(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/userRel/v1/userRel/deleteUserRel', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  deleteOrg(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/org/v1/org/deleteOrg', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
    deleteOrgNew(param) {
    return new Promise((resolve, reject) => {
      req.remove(uc + '/api/org/v1/org/deleteOrg', param).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getAllRoles() {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/role/v1/roles/getAll').then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getAllJobs() {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/job/v1/jobs/getJobList', {}).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getAllPosts() {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/org/v1/orgPosts/getOrgPostPage', {}).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getTokenByUserName(username) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/user/v1/user/getTokenByUserUserName?username=' + username).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getTokenV2ByUserName(username, cb, errorCb) {
    req.post(uc + '/api/user/v1/user/getTokenByUserUserName?username=' + username).then(
      (response) => {
        cb(response.data)
      },
      (error) => {
        errorCb(error)
      }
    )
  },
  getDefaultPwdStrategy(params) {
    return new Promise((resolve, reject) => {
      req.get(`${uc}/api/pwdStrategy/v1/getDefault?tenantId=` + params.tenantId).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getDefPwdStrategy(cb) {
    req.get(uc + '/api/pwdStrategy/v1/getDefault').then((response) => {
      cb(response.data)
    })
  },
  saveDefaultPwdStrategy(param) {
    return new Promise((resolve, reject) => {
      req.post(uc + '/api/pwdStrategy/v1/save', param).then(
        (resp) => {
          resolve(resp.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  saveLayoutRole(params) {
    return new Promise((resovle, reject) => {
      req
        .request({
          url: `${uc}/api/role/v1/roleUser/saveLayoutRoles`,
          method: 'POST',
          params: params,
          dataType: 'json'
        })
        .then(function (rep) {
          resovle(rep.data)
        })
        .catch(function (error) {
          reject(error.message)
        })
    })
  },
  getTicket(userId, timeout) {
    return new Promise((resolve, reject) => {
      req
        .post(uaa + '/tokens/oauth/ticket', {
          userId: userId,
          timeout: timeout
        })
        .then(
          (response) => {
            resolve(response.data.value)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },
  getTicketByUserId(userId) {
    return new Promise((resolve, reject) => {
      req.get(uaa + '/tokens/ticket?userId=' + userId).then(
        (response) => {
          resolve(response.data.value)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  GETTAXTYPEENUM(cb) {
    req.get(`${portal}/sys/list_config/getTaxTypeEnum`, {}).then((response) => {
      cb(response)
    })
  },
  getOnlineUserCount(tenantId) {
    return new Promise((resolve, reject) => {
      req.get(uaa + '/tokens/count?tenantId=' + tenantId).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getOnlineUser(tenantId, page, limit, code) {
    return new Promise((resolve, reject) => {
      req.get(uaa + '/tokens/?tenantId=' + tenantId + '&page=' + page + '&limit=' + limit + '&code=' + code).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  logout(token) {
    return new Promise((resolve, reject) => {
      req.get(uaa + '/oauth/remove/token?token=' + token).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  // 美团打车-分配员工
  saveSqtRole(params) {
    return new Promise((resovle, reject) => {
      req
        .put('${third}/meiTuan/third_sqt_role/', params)
        .then(function (rep) {
          resovle(rep.data)
        })
        .catch(function (error) {
          reject(error.message)
        })
    })
  },
  // 美团打车-分配员工
  getYongyouPageList(params, id, corporateId) {
    return new Promise((resovle, reject) => {
      req
        .post('${third}/org/getPageById?id=' + id + '&corporateId=' + corporateId, params)
        .then(function (rep) {
          resovle(rep.data)
        })
        .catch(function (error) {
          reject(error.message)
        })
    })
  },
  getSupplierGetPageByIdList(queryFilter, params) {
    return new Promise((resovle, reject) => {
      req
        .post('${third}/supplier/getPageById' + req.formatGetUri(params), queryFilter)
        .then(function (rep) {
          resovle(rep.data)
        })
        .catch(function (error) {
          reject(error.message)
        })
    })
  },
  getCustomGetPageByIdList(queryFilter, params) {
    return new Promise((resovle, reject) => {
      req
        .post('${third}/customer/getPageById' + req.formatGetUri(params), queryFilter)
        .then(function (rep) {
          resovle(rep.data)
        })
        .catch(function (error) {
          reject(error.message)
        })
    })
  }
}
